import { render, staticRenderFns } from "./ShipmentsReport.vue?vue&type=template&id=6c162d21&scoped=true"
import script from "./ShipmentsReport.vue?vue&type=script&lang=js"
export * from "./ShipmentsReport.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsReport.vue?vue&type=style&index=0&id=6c162d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c162d21",
  null
  
)

export default component.exports